import React from 'react';
import { UpvoteIcon, DownvoteIcon } from './Icons';

interface VoteButtonProps {
  type: 'upvote' | 'downvote';
  count: number;
  isActive?: boolean;
  onVote: () => void;
  disabled?: boolean;
}

const VoteButton: React.FC<VoteButtonProps> = ({
  type,
  count,
  isActive = false,
  onVote,
  disabled = false
}) => {
  const isUpvote = type === 'upvote';
  
  const buttonClass = `vote-button ${type} ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`;

  return (
    <button
      className={buttonClass}
      onClick={onVote}
      disabled={disabled}
      title={`${isUpvote ? 'Upvote' : 'Downvote'} (${count})`}
    >
      <span className="vote-icon" aria-hidden>
        {isUpvote ? <UpvoteIcon size={14} /> : <DownvoteIcon size={14} />}
      </span>
      <span className="vote-count">{count}</span>
    </button>
  );
};

export default VoteButton;
